import { UI_PRIMITIVE__context_menu_root, UI_PRIMITIVE__context_menu_trigger } from '@/components/ui/context_menu/UI_PRIMITIVE__context_menu';
import { UI_PRIMITIVE__context_menu_content } from '@/components/ui/context_menu/UI_PRIMITIVE__context_menu_content';
import { CONTEXT_MENU_ITEM__image__show_source } from '@/pages/_base/image/CONTEXT_MENU_ITEM__image__show_source';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { CONTEXT_MENU_ITEM__image__copy_to_clipboard } from './CONTEXT_MENU_ITEM__image__copy_to_clipboard';
import { CONTEXT_MENU_ITEM__image__download } from './CONTEXT_MENU_ITEM__image__download';

interface PROPS {
  image_asset: DTO__image_asset;
  children: React.ReactNode;
}

export function CONTEXT_MENU__image({ image_asset, children }: PROPS) {
  /*
   * RENDERS
   */
  function render_with_context_menu(out: React.ReactNode) {
    return (
      <UI_PRIMITIVE__context_menu_root>
        <UI_PRIMITIVE__context_menu_trigger asChild>{out}</UI_PRIMITIVE__context_menu_trigger>

        <UI_PRIMITIVE__context_menu_content className="flex flex-col gap-1">{render_items()}</UI_PRIMITIVE__context_menu_content>
      </UI_PRIMITIVE__context_menu_root>
    );
  }

  function render_items() {
    return (
      <>
        <CONTEXT_MENU_ITEM__image__show_source image_asset={image_asset} />
        <CONTEXT_MENU_ITEM__image__copy_to_clipboard image_asset={image_asset} />
        <CONTEXT_MENU_ITEM__image__download image_asset={image_asset} />
      </>
    );
  }

  /*
   * HTML
   */

  return render_with_context_menu(children);
}
